import { Injectable } from '@angular/core';
import { Currency, CurrencyViewModel } from '@models/currency';
import { FormDataService } from '@services/form-data/form-data.service';
import { MdsOptionGeneric } from '@utility/utility';
import { BehaviorSubject, catchError, filter, map, Observable, shareReplay, tap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CurrencyStateService {
    constructor(private formService: FormDataService) {}
    private readonly currencies = new BehaviorSubject<CurrencyViewModel[] | null>(null);
    private activeLoading = false;

    public getCurrencies(): Observable<CurrencyViewModel[]> {
        if (this.currencies.getValue() === null && this.activeLoading === false) {
            this.activeLoading = true;
            this.formService
                .getCurrencies()
                .pipe(
                    tap((res) => {
                        this.currencies.next(
                            res.map((currency) => {
                                return <CurrencyViewModel>{
                                    ...currency,
                                    value: currency.isocode,
                                    viewValue: currency.isocode,
                                };
                            })
                        );
                    }),
                    catchError((error) => {
                        throw error;
                    })
                )
                .subscribe(() => (this.activeLoading = false));
        }

        return this.currencies.asObservable().pipe(filter(Boolean));
    }

    public getCurrencyByCode(currencyCode: string): Observable<CurrencyViewModel | undefined> {
        return this.getCurrencies().pipe(
            map((currencies) => {
                return currencies.find((currency) => currency.isocode === currencyCode);
            }),
            shareReplay(1)
        );
    }

    public getCurrencyUSD(): Observable<CurrencyViewModel | undefined> {
        return this.getCurrencyByCode('USD');
    }

    private readonly currenciesAsMdsOptions = this.currencies.pipe(
        filter(Boolean),
        map((currencies) => {
            return (
                currencies?.map<MdsOptionGeneric<Currency>>((currency) => ({
                    value: currency,
                    viewValue: currency.isocode,
                })) ?? []
            );
        }),
        shareReplay(1)
    );
    getCurrenciesAsMdsOptions(): Observable<MdsOptionGeneric<Currency>[]> {
        return this.currenciesAsMdsOptions;
    }
}
